export type RealtimeConnectionState =
    | 'disconnected'
    | 'connecting'
    | 'connected'
    | 'reconnecting'
    | 'error';

export const KNOWN_REALTIME_JOB_TYPES = [
    'DocumentImport',
    'SharePointImport',
    'DocumentClassification',
    'DocumentIntelligence',
    'DocumentPreview',
    'BuildingDocumentExport',
    'SelectedBuildingDocumentExport',
    'DocumentPackExport',
] as const;

export type KnownRealtimeJobType = (typeof KNOWN_REALTIME_JOB_TYPES)[number];

export type RealtimeJobType = string;

export type RealtimeJobStatus =
    | 'Queued'
    | 'Started'
    | 'Progress'
    | 'Completed'
    | 'Failed'
    | 'Skipped'
    | 'Expired';

export interface JobProgressMessage {
    jobId: string;
    jobType: RealtimeJobType;
    status: RealtimeJobStatus;
    message: string | null;
    percentComplete: number | null;
    occurredAtUtc: string;
    correlationId: string | null;
    documentPublicId: string | null;
    buildingId: string | null;
    packId: string | null;
    failureCode: string | null;
    actualBytes: number | null;
    allowedBytes: number | null;
    completedItems?: number | null;
    totalItems?: number | null;
}

export interface RealtimeDiagnostics {
    readonly connectionId: string | null;
    readonly connectedAtUtc: string | null;
    readonly disconnectedAtUtc: string | null;
    readonly eventName: string;
    readonly bufferLimit: number;
    readonly receivedMessageCount: number;
    readonly malformedMessageCount: number;
    readonly reconnectCount: number;
    readonly lastMessageReceivedAtUtc: string | null;
}
